<Teleport to="#app"><div class="modal-scrim" @click="$emit('close')"><slot></slot></div></Teleport>